
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'feeling-selection',
    templateUrl: 'feeling-selection.component.html',
})

export class FeelingSelectionComponent {

    @Input() selectedFeelings: any;
    @Input() selectedFeeling: any;
    @Input() selectionList;
    @Input() nodeClassList: any;
    @Input() lang: any;
    @Input() selectedSymptom : any;

    @Output() changeRating = new EventEmitter();
    @Output() changePrimary = new EventEmitter();

    updateRating(selectedFeeling, status, selectedSymptom, isAnamnestic = 0) {
        this.changeRating.emit({
            selectedFeeling : selectedFeeling,
            status : status,
            selectedSymptom : selectedSymptom,
            isAnamnestic : isAnamnestic
        });
    }

    updatePrimary(feeling) {
        this.changePrimary.emit({
            feeling: feeling
        })
    }
}
